import styled from '@emotion/styled';
import { StepContainer } from 'UI';

export const VariantContainer = styled(StepContainer)`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const VariantWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;
